export function errorMessageOf(error: unknown): string | null {
  if (error === undefined) return null
  if (typeof error === 'string') return error

  const message = typeof error === 'object' && error !== null ? (error as { message?: unknown }).message : undefined

  return typeof message === 'string' ? message : 'Unknown error'
}
